import { render, staticRenderFns } from "./AccessAuthority.vue?vue&type=template&id=b30cf542&scoped=true"
import script from "./AccessAuthority.vue?vue&type=script&lang=js"
export * from "./AccessAuthority.vue?vue&type=script&lang=js"
import style0 from "./AccessAuthority.vue?vue&type=style&index=0&id=b30cf542&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b30cf542",
  null
  
)

export default component.exports